// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leader-board-container {
  flex: 1 1;
  width:100%;
  flex-direction: column;
  display: flex;
}

.leader-board-header-container {
  flex: 1 1;
  width:100%;
  display: flex;
  margin: 0px;
  padding:0px;
  justify-content: center;
  /* margin-bottom: 3px; */
  align-items: center;
}

.leader-board-row-container {
  flex: 1 1;
  width:100%;
}


.leader-board-header-title-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-left: 10px; */
}

.leader-board-header-title-container h3 {
  padding: .5em;
  margin: 0px; 
}

.leader-board-table-container {
  flex: 5 1;
  width:100%;
  display: flex;
  flex-direction: column;
  /* background-color: rgb(132, 153, 192); */
  gap:2px
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Modal/modals/HamburgerMenu/pages/Default/LeaderBoard/LeaderBoard.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,UAAU;EACV,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,UAAU;EACV,aAAa;EACb,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,UAAU;AACZ;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C;AACF","sourcesContent":[".leader-board-container {\n  flex: 1;\n  width:100%;\n  flex-direction: column;\n  display: flex;\n}\n\n.leader-board-header-container {\n  flex: 1;\n  width:100%;\n  display: flex;\n  margin: 0px;\n  padding:0px;\n  justify-content: center;\n  /* margin-bottom: 3px; */\n  align-items: center;\n}\n\n.leader-board-row-container {\n  flex: 1;\n  width:100%;\n}\n\n\n.leader-board-header-title-container {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* margin-left: 10px; */\n}\n\n.leader-board-header-title-container h3 {\n  padding: .5em;\n  margin: 0px; \n}\n\n.leader-board-table-container {\n  flex: 5;\n  width:100%;\n  display: flex;\n  flex-direction: column;\n  /* background-color: rgb(132, 153, 192); */\n  gap:2px\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
